import { __awaiter, __decorate, __extends, __generator, __spreadArrays } from "tslib";
import React from 'react';
import { withTranslation } from '../../../component-decorators/with-translation';
import { HttpClient } from '@wix/http-client';
import { Box, CustomModalLayout, Dropdown, FileUpload, SectionHelper, FormField, Heading, InputArea, Loader, Modal, Tag, Text, TextButton, Tooltip, } from 'wix-style-react';
import { Captcha } from 'wix-ui-core/captcha';
import { composer } from '../../../component-decorators/composer';
import { Attachement } from 'wix-ui-icons-common';
import s from './support-modal.scss';
import { v4 } from 'uuid';
import { sendCloseSupportModalBiEvent, sendSupportModalOpenedBiEvent, } from '../../../bi/biEvents';
import { MediaPlatform } from 'media-platform-js-sdk/browser';
var UploadFileRequest = require('media-platform-js-sdk/browser').file
    .UploadFileRequest;
export var ManageAppsSupportModalTopic;
(function (ManageAppsSupportModalTopic) {
    ManageAppsSupportModalTopic["BILLING_AND_UPGRADES"] = "Billing and Upgrades";
    ManageAppsSupportModalTopic["TECHNICAL_SUPPORT"] = "Technical Support";
    ManageAppsSupportModalTopic["FEATURE_REQUEST"] = "Feature Request";
    ManageAppsSupportModalTopic["OTHER"] = "Other";
})(ManageAppsSupportModalTopic || (ManageAppsSupportModalTopic = {}));
var TOTAL_FILES_SIZE_LIMIT_IN_BYTES = 5000000; // 5mb per file
var MEDIA_PLATFORM_APP_MARKET_BASE_URL = 'https://wixmp-0a05a7298b58ea7e81a8f843.wixmp.com';
var MEDIA_PLATFORM_APP_MARKET_DOMAIN = 'wixmp-0a05a7298b58ea7e81a8f843.appspot.com';
var getMediaPlatformAppMarketAuthenticationUrl = function (baseUrl) {
    return baseUrl + "/_serverless/app-support/media-platform/auth-header";
};
var getSendSupportMailEndpoint = function (baseUrl) {
    return baseUrl + "/_serverless/app-support/send-mail";
};
var httpClient = new HttpClient();
var SupportModal = /** @class */ (function (_super) {
    __extends(SupportModal, _super);
    function SupportModal(props) {
        var _this = _super.call(this, props) || this;
        _this.captchaRef = undefined;
        _this.handleDescriptionChange = function (e) {
            var val = e.target.value;
            _this.setState({
                description: val,
            });
        };
        _this.handleTopicChange = function (_a) {
            var id = _a.id;
            _this.setState({ topic: id });
        };
        _this.getSendEmailRequestObject = function () {
            var _a = _this.state, description = _a.description, topic = _a.topic, files = _a.files;
            var _b = _this.props, app = _b.app, msId = _b.msId;
            return {
                description: description,
                topic: topic,
                files: files,
                appInstanceId: app.instanceId,
                appID: app.webSolutionBase.id,
                msid: msId,
            };
        };
        _this.isFileTooBig = function (fileSizeInBytes) {
            return fileSizeInBytes > TOTAL_FILES_SIZE_LIMIT_IN_BYTES;
        };
        _this.uploadFileToMediaPlatform = function (selectedFile, currentFiles) {
            var path = v4() + "/" + selectedFile.name.replace(/\s+/g, '');
            var mimeType = selectedFile.type;
            var acl = 'public';
            var uploadConfigurationRequest = {
                mimeType: mimeType,
                path: path,
                size: selectedFile.size,
                acl: acl,
            };
            return _this.state.mediaPlatform.fileManager
                .getUploadConfiguration(uploadConfigurationRequest)
                .then(function (_a) {
                var uploadToken = _a.uploadToken, uploadUrl = _a.uploadUrl;
                var uploadRequest = new UploadFileRequest({
                    acl: acl,
                    mimeType: mimeType,
                });
                return _this.state.mediaPlatform.fileManager
                    .uploadFile(path, selectedFile, uploadRequest, uploadToken, uploadUrl)
                    .on('upload-success', function () {
                    var fileUrl = MEDIA_PLATFORM_APP_MARKET_BASE_URL + "/" + path;
                    var fileToSend = {
                        filename: selectedFile.name.replace(/\s+/g, ''),
                        path: fileUrl,
                    };
                    _this.setState({
                        files: __spreadArrays(currentFiles, [fileToSend]),
                        isUploadingFile: false,
                    });
                })
                    .on('upload-error', function (e) {
                    console.error('failed to upload file:', e);
                    _this.setState({
                        isUploadingFile: false,
                        files: __spreadArrays(currentFiles),
                        showError: "FILE_UPLOAD_ERROR" /* FILE_UPLOAD_ERROR */,
                    });
                });
            })
                .catch(function (e) {
                console.error('failed to get upload configuration: ', e);
                _this.setState({
                    isUploadingFile: false,
                    files: __spreadArrays(currentFiles),
                    showError: "FILE_UPLOAD_ERROR" /* FILE_UPLOAD_ERROR */,
                });
            });
        };
        _this.onFileSelect = function (selectedFiles) { return __awaiter(_this, void 0, void 0, function () {
            var currentFiles, selectedFile;
            var _this = this;
            return __generator(this, function (_a) {
                currentFiles = this.state.files;
                selectedFile = selectedFiles[0];
                if (this.isFileTooBig(selectedFile.size)) {
                    this.setState({ showError: "FILE_SIZE_ERROR" /* FILE_SIZE_ERROR */ });
                    return [2 /*return*/];
                }
                if (currentFiles.findIndex(function (file) {
                    return file.filename.replace(/\s+/g, '') ===
                        selectedFile.name.replace(/\s+/g, '');
                }) === -1) {
                    this.setState({
                        files: __spreadArrays(currentFiles, [
                            { filename: selectedFile.name.replace(/\s+/g, '') },
                        ]),
                        showError: '',
                        isUploadingFile: true,
                    }, function () { return __awaiter(_this, void 0, void 0, function () {
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, this.uploadFileToMediaPlatform(selectedFile, currentFiles)];
                                case 1:
                                    _a.sent();
                                    return [2 /*return*/];
                            }
                        });
                    }); });
                }
                return [2 /*return*/];
            });
        }); };
        _this.removeFile = function (id) {
            var currentFiles = __spreadArrays(_this.state.files);
            _this.setState({
                files: currentFiles.filter(function (_a) {
                    var filename = _a.filename;
                    return filename !== id;
                }),
            });
        };
        _this.getVerifiedToken = function () {
            if (_this.captchaRef) {
                return _this.captchaRef.getVerificationToken();
            }
            return '';
        };
        _this.validateInputs = function () {
            var state = {
                descriptionStatus: undefined,
                topicStatus: undefined,
                captchaRefStatus: undefined,
                showError: undefined,
            };
            var result = true;
            if (_this.state.description === '' || _this.state.description.length < 20) {
                state.descriptionStatus = 'error';
                result = false;
            }
            if (_this.state.topic === '') {
                state.topicStatus = 'error';
                result = false;
            }
            if (!_this.isCaptchaVerified()) {
                state.captchaRefStatus = false;
                state.showError = "GENERAL_ERROR" /* GENERAL_ERROR */;
                result = false;
            }
            _this.setState(state);
            return result;
        };
        _this.sendEmail = function () {
            var _a = _this.props, closeModal = _a.closeModal, showUserActionNotification = _a.showUserActionNotification, authorizationHeader = _a.authorizationHeader, baseUrl = _a.baseUrl, app = _a.app, t = _a.t;
            var validInputs = _this.validateInputs();
            if (validInputs) {
                var endpoint = getSendSupportMailEndpoint(baseUrl);
                httpClient
                    .post(endpoint, _this.getSendEmailRequestObject(), {
                    headers: {
                        'content-type': 'application/json',
                        authorization: authorizationHeader,
                        withCredentials: true,
                    },
                })
                    .then(function () {
                    showUserActionNotification &&
                        showUserActionNotification({
                            message: t('manage-apps.support-modal.success'),
                            biName: 'support-modal',
                            type: 'SUCCESS',
                        });
                    closeModal();
                })
                    .catch(function (e) {
                    console.error(e);
                    showUserActionNotification &&
                        showUserActionNotification({
                            message: t('manage-apps.support-modal.fail'),
                            biName: 'support-modal',
                            type: 'ERROR',
                        });
                    closeModal();
                });
            }
        };
        _this.onCancelModal = function () {
            var _a = _this.props, app = _a.app, origin = _a.origin, msId = _a.msId, closeModal = _a.closeModal, clickSource = _a.clickSource, pageName = _a.pageName, editorType = _a.editorType;
            sendCloseSupportModalBiEvent(app, origin, msId, !!app.instanceId, clickSource || 'context_menu', pageName || 'manage_apps', editorType);
            closeModal();
        };
        _this.state = {
            description: '',
            topic: '',
            files: [],
            showError: '',
            isUploadingFile: false,
            mediaPlatform: new MediaPlatform({
                domain: MEDIA_PLATFORM_APP_MARKET_DOMAIN,
                authenticationUrl: getMediaPlatformAppMarketAuthenticationUrl(_this.props.baseUrl),
            }),
            hasCounter: false,
            descriptionStatus: undefined,
            topicStatus: undefined,
            captchaRefStatus: undefined,
            verifiedToken: '',
        };
        return _this;
    }
    SupportModal.prototype.componentDidMount = function () {
        var _a = this.props, app = _a.app, origin = _a.origin, msId = _a.msId, clickSource = _a.clickSource, pageName = _a.pageName, editorType = _a.editorType;
        sendSupportModalOpenedBiEvent(app, origin, msId, !!app.instanceId, clickSource || 'context_menu', pageName || 'manage_apps', editorType);
    };
    SupportModal.prototype.isCaptchaVerified = function () {
        if (this.captchaRef) {
            return this.captchaRef.isVerified();
        }
        return false;
    };
    SupportModal.prototype.render = function () {
        var _this = this;
        var _a = this.props, t = _a.t, app = _a.app;
        var _b = this.state, description = _b.description, topic = _b.topic, files = _b.files, showError = _b.showError, isUploadingFile = _b.isUploadingFile;
        var appIcon = app && app.webSolutionBase && app.webSolutionBase.icon;
        var appName = app &&
            app.webSolutionBase &&
            app.webSolutionBase.name &&
            app.webSolutionBase.name.replace('&amp;', '&');
        return (React.createElement(Modal, { isOpen: true },
            React.createElement(CustomModalLayout, { width: "600px", height: "659px", title: React.createElement(SupportModalTitle, { appIcon: appIcon, appName: appName }), primaryButtonText: t('manage-apps.support-modal.send'), primaryButtonOnClick: this.sendEmail, primaryButtonProps: { disabled: isUploadingFile }, secondaryButtonText: t('manage-apps.support-modal.cancel'), secondaryButtonOnClick: this.onCancelModal, onCloseButtonClick: this.onCancelModal },
                showError && (React.createElement(Box, { marginBottom: "12px", direction: "vertical" },
                    React.createElement(SectionHelper, { appearance: "danger", showCloseButton: false }, showError === "FILE_SIZE_ERROR" /* FILE_SIZE_ERROR */
                        ? t('manage-apps.support-modal.file-size-error')
                        : showError === "GENERAL_ERROR" /* GENERAL_ERROR */
                            ? t('manage-apps.support-modal.general-error')
                            : t('manage-apps.support-modal.file-upload-error')))),
                React.createElement(Box, { direction: "vertical" },
                    React.createElement(Box, { marginBottom: "30px", direction: "vertical" },
                        React.createElement(FormField, { required: true, label: t('manage-apps.support-modal.form.field.topic') },
                            React.createElement(Dropdown, { dataHook: "support-modal-topic-dropdown", onSelect: this.handleTopicChange, placeholder: t('manage-apps.support-modal.form.field.topic.placeholder'), options: [
                                    {
                                        id: ManageAppsSupportModalTopic.BILLING_AND_UPGRADES,
                                        value: t('manage-apps.support-modal.form.field.topic.option.billing-and-upgrades'),
                                    },
                                    {
                                        id: ManageAppsSupportModalTopic.TECHNICAL_SUPPORT,
                                        value: t('manage-apps.support-modal.form.field.topic.option.technical-support'),
                                    },
                                    {
                                        id: ManageAppsSupportModalTopic.FEATURE_REQUEST,
                                        value: t('manage-apps.support-modal.form.field.topic.option.feature-request'),
                                    },
                                    {
                                        id: ManageAppsSupportModalTopic.OTHER,
                                        value: t('manage-apps.support-modal.form.field.topic.option.other'),
                                    },
                                ], statusMessage: t('manage-apps.support-modal.topic-error'), status: this.state.topicStatus, onFocus: function () { return _this.setState({ topicStatus: undefined }); } }))),
                    React.createElement(Box, { marginBottom: "6px", direction: "vertical" },
                        React.createElement(FormField, { required: true, label: t('manage-apps.support-modal.form.field.description') },
                            React.createElement(InputArea, { dataHook: "description-input", hasCounter: this.state.hasCounter, maxLength: 2048, status: this.state.descriptionStatus, onChange: this.handleDescriptionChange, minHeight: "160px", onFocus: function () {
                                    return _this.setState({
                                        hasCounter: true,
                                        descriptionStatus: undefined,
                                    });
                                }, onBlur: function () { return _this.setState({ hasCounter: false }); }, placeholder: t('manage-apps.support-modal.form.field.description.placeholder'), value: description, statusMessage: t('manage-apps.support-modal.description-error'), tooltipPlacement: 'left' }))),
                    React.createElement(Box, { className: s.attachments, verticalAlign: "top", maxHeight: "54px", marginBottom: "30px" },
                        files.map(function (file) {
                            var isFileRemovable = !!file.path;
                            return (React.createElement(Tag, { id: file.filename, key: file.filename, className: s.tag, maxWidth: 216, onRemove: _this.removeFile, removable: isFileRemovable, size: "small", dataHook: "uploaded-file-tag-" + file.filename, thumb: isFileRemovable ? null : React.createElement(Loader, { size: "tiny" }) }, file.filename));
                        }),
                        files.length < 4 && (React.createElement(Tooltip, { content: t('manage-apps.support-modal.attach-file-button.tooltip') },
                            React.createElement(FileUpload, { dataHook: "file-upload-button", className: s.uploadButton, onChange: this.onFileSelect, accept: ".jpeg,.gif,.png,.jpg" }, function (_a) {
                                var openFileUploadDialog = _a.openFileUploadDialog;
                                return (React.createElement(TextButton, { dataHook: "attach-file-text-button", onClick: openFileUploadDialog, prefixIcon: React.createElement(Attachement, null), disabled: isUploadingFile || files.length > 3 }, t('manage-apps.support-modal.attach-file-button')));
                            })))),
                    React.createElement(Box, null,
                        React.createElement(Captcha, { sitekey: "6LejwKAUAAAAACs5B-wV9ndjxrE49x3lGztPznl_", loader: React.createElement(Loader, { size: "tiny" }), ref: function (e) { return (_this.captchaRef = e); }, onVerify: function () {
                                return _this.setState({
                                    verifiedToken: _this.getVerifiedToken(),
                                });
                            } }))))));
    };
    SupportModal = __decorate([
        withTranslation
    ], SupportModal);
    return SupportModal;
}(React.Component));
export { SupportModal };
var AppIcon = function (_a) {
    var src = _a.src;
    return (React.createElement("img", { "data-hook": "support-modal-app-icon", src: src, alt: "app-icon", style: {
            width: '60px',
            height: '60px',
            marginRight: '18px',
            borderRadius: '6px',
            border: '1px solid rgb(240, 244, 247)',
            boxSizing: 'border-box',
        } }));
};
var SupportModalTitle = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, appIcon = _a.appIcon, appName = _a.appName;
    return (React.createElement(Box, { verticalAlign: "top" },
        React.createElement(AppIcon, { src: appIcon }),
        React.createElement(Box, { direction: "vertical", verticalAlign: "top" },
            React.createElement(Heading, { appearance: "H2", dataHook: "support-modal-title" }, t('manage-apps.support-modal.title')),
            React.createElement(Text, { secondary: true, dataHook: "support-modal-subtitle" }, t('manage-apps.support-modal.subtitle', { appName: appName }).replace('&amp;', '&')))));
});
//# sourceMappingURL=support-modal.js.map